import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui';

import familiesForSafeStreetsLogo from '#src/app/pages/nonprofit/landing/shared/assets/Families-For-Safe-Streets.png';
import incomeMovementLogo from '#src/app/pages/nonprofit/landing/shared/assets/Income-Movement.png';
import riseLogo from '#src/app/pages/nonprofit/landing/shared/assets/Rise.png';
import theHumaneLeagueLogo from '#src/app/pages/nonprofit/landing/shared/assets/The-Humane-League.png';

const LOGO_HEIGHT = 80;

const LOGOS: ReadonlyArray<{ src: string; alt: string }> = [
	{ src: theHumaneLeagueLogo, alt: 'The Humane League' },
	{ src: incomeMovementLogo, alt: 'Income Movement' },
	{ src: riseLogo, alt: 'Rise' },
	{ src: familiesForSafeStreetsLogo, alt: 'Families for Safe Streets' },
];

export function TrustedBy(): JSX.Element {
	return (
		<div className="container my-8" data-qa="nonprofit-trusted-by-section">
			<div className="flex flex-col items-center justify-center gap-6 lg:flex-row">
				<Text as="h2" variant="heading" fontWeight="bold" className="text-size-body-large md:text-size-body-xl">
					<b>Trusted by</b>
				</Text>
				<div
					className="flex w-full min-w-0 flex-row items-center justify-start gap-6 overflow-x-auto overflow-y-hidden md:w-auto md:justify-center"
					style={{ height: LOGO_HEIGHT }}
				>
					{LOGOS.map(({ src, alt }) => (
						<img key={alt} src={src} alt={alt} className="h-full w-auto shrink-0 object-contain" height={LOGO_HEIGHT} />
					))}
				</div>
			</div>
		</div>
	);
}
